export const PF_EXPORT_SECTION_NAME = {
  SELECT_ALL: '(Select All)',

  BASIC_INFO: 'Basic Info',
  POSITION_TITLE: 'Position Title',
  POSITION_CODE: 'Position Code',
  STAFF_ID: 'Staff ID',
  STAFF_NAME: 'Staff Name',

  POSITION_DETAILS: 'Position Details',
  BUSINESS: 'Business',
  SECTOR: 'Sector',
  OPU: 'OPU',
  DIVISION: 'Division',
  DEPARTMENT: 'Department',
  JOB_GRADE_EQUI_EST: 'Job Grade / Equi Job Grade / Est Job Grade',
  SKG: 'SKG',

  SPUR: 'SPUR',
  JOB_FAMILY: 'Job Family',
  SUB_JOB_FAMILY: 'Sub Job Family',
  JOB_FUNCTION: 'Job Function',

  CRITICAL_POSITION_STATUS: 'Critical Position Status',
  CRITICAL_POSITION_CATEGORY: 'Critical Position Category',

  INCUMBENT_DETAILS: 'Incumbent Details',
  SALARY_GRADE: 'Salary Grade',
  YEARS_TO_RETIRE: 'Years to Retire',
  YEARS_IN_POSITION: 'Years in Position',
  WORK_LOCATION: 'Work Location',
};

export const PF_EXPORT_OPTIONS = [
  {
    label: PF_EXPORT_SECTION_NAME.SELECT_ALL,
    value: PF_EXPORT_SECTION_NAME.SELECT_ALL,
  },
  {
    label: PF_EXPORT_SECTION_NAME.BASIC_INFO,
    value: PF_EXPORT_SECTION_NAME.BASIC_INFO,
    children: [
      { label: PF_EXPORT_SECTION_NAME.POSITION_TITLE, value: PF_EXPORT_SECTION_NAME.POSITION_TITLE },
      { label: PF_EXPORT_SECTION_NAME.POSITION_CODE, value: PF_EXPORT_SECTION_NAME.POSITION_CODE },
      { label: PF_EXPORT_SECTION_NAME.STAFF_ID, value: PF_EXPORT_SECTION_NAME.STAFF_ID },
      { label: PF_EXPORT_SECTION_NAME.STAFF_NAME, value: PF_EXPORT_SECTION_NAME.STAFF_NAME },
    ],
  },
  {
    label: PF_EXPORT_SECTION_NAME.POSITION_DETAILS,
    value: PF_EXPORT_SECTION_NAME.POSITION_DETAILS,
    children: [
      { label: PF_EXPORT_SECTION_NAME.BUSINESS, value: PF_EXPORT_SECTION_NAME.BUSINESS },
      { label: PF_EXPORT_SECTION_NAME.SECTOR, value: PF_EXPORT_SECTION_NAME.SECTOR },
      { label: PF_EXPORT_SECTION_NAME.OPU, value: PF_EXPORT_SECTION_NAME.OPU },
      { label: PF_EXPORT_SECTION_NAME.DIVISION, value: PF_EXPORT_SECTION_NAME.DIVISION },
      { label: PF_EXPORT_SECTION_NAME.DEPARTMENT, value: PF_EXPORT_SECTION_NAME.DEPARTMENT },
      { label: PF_EXPORT_SECTION_NAME.JOB_GRADE_EQUI_EST, value: PF_EXPORT_SECTION_NAME.JOB_GRADE_EQUI_EST },
      { label: PF_EXPORT_SECTION_NAME.SKG, value: PF_EXPORT_SECTION_NAME.SKG },
    ],
  },
  {
    label: PF_EXPORT_SECTION_NAME.SPUR,
    value: PF_EXPORT_SECTION_NAME.SPUR,
    children: [
      { label: PF_EXPORT_SECTION_NAME.JOB_FAMILY, value: PF_EXPORT_SECTION_NAME.JOB_FAMILY },
      { label: PF_EXPORT_SECTION_NAME.SUB_JOB_FAMILY, value: PF_EXPORT_SECTION_NAME.SUB_JOB_FAMILY },
      { label: PF_EXPORT_SECTION_NAME.JOB_FUNCTION, value: PF_EXPORT_SECTION_NAME.JOB_FUNCTION },
    ],
  },
  {
    label: PF_EXPORT_SECTION_NAME.CRITICAL_POSITION_STATUS,
    value: PF_EXPORT_SECTION_NAME.CRITICAL_POSITION_STATUS,
    children: [{ label: PF_EXPORT_SECTION_NAME.CRITICAL_POSITION_CATEGORY, value: PF_EXPORT_SECTION_NAME.CRITICAL_POSITION_CATEGORY }],
  },
  {
    label: PF_EXPORT_SECTION_NAME.INCUMBENT_DETAILS,
    value: PF_EXPORT_SECTION_NAME.INCUMBENT_DETAILS,
    children: [
      { label: PF_EXPORT_SECTION_NAME.SALARY_GRADE, value: PF_EXPORT_SECTION_NAME.SALARY_GRADE },
      { label: PF_EXPORT_SECTION_NAME.YEARS_TO_RETIRE, value: PF_EXPORT_SECTION_NAME.YEARS_TO_RETIRE },
      { label: PF_EXPORT_SECTION_NAME.YEARS_IN_POSITION, value: PF_EXPORT_SECTION_NAME.YEARS_IN_POSITION },
      { label: PF_EXPORT_SECTION_NAME.WORK_LOCATION, value: PF_EXPORT_SECTION_NAME.WORK_LOCATION },
    ],
  },
];

export const PF_EXPORT_DEFAULT_SELECT_OPTIONS = [
  { label: PF_EXPORT_SECTION_NAME.BASIC_INFO, value: PF_EXPORT_SECTION_NAME.BASIC_INFO },
  { label: PF_EXPORT_SECTION_NAME.POSITION_TITLE, value: PF_EXPORT_SECTION_NAME.POSITION_TITLE },
  { label: PF_EXPORT_SECTION_NAME.POSITION_CODE, value: PF_EXPORT_SECTION_NAME.POSITION_CODE },
  { label: PF_EXPORT_SECTION_NAME.STAFF_ID, value: PF_EXPORT_SECTION_NAME.STAFF_ID },
  { label: PF_EXPORT_SECTION_NAME.STAFF_NAME, value: PF_EXPORT_SECTION_NAME.STAFF_NAME },
  { label: PF_EXPORT_SECTION_NAME.POSITION_DETAILS, value: PF_EXPORT_SECTION_NAME.POSITION_DETAILS },
  { label: PF_EXPORT_SECTION_NAME.BUSINESS, value: PF_EXPORT_SECTION_NAME.BUSINESS },
  { label: PF_EXPORT_SECTION_NAME.SECTOR, value: PF_EXPORT_SECTION_NAME.SECTOR },
  { label: PF_EXPORT_SECTION_NAME.OPU, value: PF_EXPORT_SECTION_NAME.OPU },
  { label: PF_EXPORT_SECTION_NAME.DIVISION, value: PF_EXPORT_SECTION_NAME.DIVISION },
  { label: PF_EXPORT_SECTION_NAME.DEPARTMENT, value: PF_EXPORT_SECTION_NAME.DEPARTMENT },
  { label: PF_EXPORT_SECTION_NAME.JOB_GRADE_EQUI_EST, value: PF_EXPORT_SECTION_NAME.JOB_GRADE_EQUI_EST },
  { label: PF_EXPORT_SECTION_NAME.SKG, value: PF_EXPORT_SECTION_NAME.SKG },
  { label: PF_EXPORT_SECTION_NAME.INCUMBENT_DETAILS, value: PF_EXPORT_SECTION_NAME.INCUMBENT_DETAILS },
  { label: PF_EXPORT_SECTION_NAME.SALARY_GRADE, value: PF_EXPORT_SECTION_NAME.SALARY_GRADE },
];

export const PF_SORTED_OPTIONS = [
  PF_EXPORT_SECTION_NAME.STAFF_ID,
  PF_EXPORT_SECTION_NAME.STAFF_NAME,
  PF_EXPORT_SECTION_NAME.POSITION_TITLE,
  PF_EXPORT_SECTION_NAME.POSITION_CODE,
];

export const PF_EXPORT_PARENT_OPTIONS = [PF_EXPORT_SECTION_NAME.SELECT_ALL, PF_EXPORT_SECTION_NAME.BASIC_INFO];

export const PF_EXPORT_CONFIG_FILTER = [
  {
    parent: PF_EXPORT_SECTION_NAME.POSITION_DETAILS,
    children: [
      { key: 'business', label: PF_EXPORT_SECTION_NAME.BUSINESS },
      { key: 'sector', label: PF_EXPORT_SECTION_NAME.SECTOR },
      { key: 'opu', label: PF_EXPORT_SECTION_NAME.OPU },
      { key: 'division', label: PF_EXPORT_SECTION_NAME.DIVISION },
      { key: 'department', label: PF_EXPORT_SECTION_NAME.DEPARTMENT },
      { key: 'job_grade', label: PF_EXPORT_SECTION_NAME.JOB_GRADE_EQUI_EST },
      { key: 'skg', label: PF_EXPORT_SECTION_NAME.SKG },
    ],
  },
  {
    parent: PF_EXPORT_SECTION_NAME.SPUR,
    children: [
      { key: 'job_family', label: PF_EXPORT_SECTION_NAME.JOB_FAMILY },
      { key: 'sub_job_family', label: PF_EXPORT_SECTION_NAME.SUB_JOB_FAMILY },
      { key: 'function', label: PF_EXPORT_SECTION_NAME.JOB_FUNCTION },
    ],
  },
  {
    parent: PF_EXPORT_SECTION_NAME.CRITICAL_POSITION_STATUS,
    children: [{ key: 'position_label', label: PF_EXPORT_SECTION_NAME.CRITICAL_POSITION_CATEGORY }],
  },
  {
    parent: PF_EXPORT_SECTION_NAME.INCUMBENT_DETAILS,
    children: [
      { key: 'salary_grade', label: PF_EXPORT_SECTION_NAME.SALARY_GRADE },
      { key: 'years_to_retire', label: PF_EXPORT_SECTION_NAME.YEARS_TO_RETIRE },
      { key: 'years_in_position', label: PF_EXPORT_SECTION_NAME.YEARS_IN_POSITION },
      { key: 'work_location', label: PF_EXPORT_SECTION_NAME.WORK_LOCATION },
    ],
  },
];

export const PF_EXPORT_FILTER_HAS_CHILDREN = ['job_grade', 'salary_grade'];
